var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAjuda(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.65 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.83,
    cy: 20.06,
    r: 1.94
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.23,7.28H8.82a.66.66,0,0,0,.65-.66,1.94,1.94,0,0,1,3.75-.69V6a2,2,0,0,1-.8,2.33c-1.76,1-3,1.77-3,4.78v2.63a.65.65,0,0,0,.64.65H12.7a.65.65,0,0,0,.65-.65V13.05c0-1,.13-1,.48-1.12a5.66,5.66,0,0,0,.63-.33,5.82,5.82,0,1,0-8.88-5,.65.65,0,0,0,.65.64Z",
    transform: "translate(-5.58 -0.81)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAjuda);
export default __webpack_public_path__ + "static/media/ajuda.f0edf4b4833cd3ec3934343463d70025.svg";
export { ForwardRef as ReactComponent };